import { PagedArray } from "app/shared/model/app.model";
import { Subject } from "rxjs";

export interface SelectorItem<T> {
	display: string,
	value: T
}

export class SelectorItem<T> {
	public static with<T>(value: T, display: string): SelectorItem<T> {
		return { display: display, value: value };
	}
	
	public static from<T>(value: PagedArray<T>, displayValue: (value: T) => string): PagedArray<SelectorItem<T>>;
	public static from<T>(value: T, displayValue: (value: T) => string): SelectorItem<T>;
	public static from<T>(value: T[], displayValue: (value: T) => string): SelectorItem<T>[];
	public static from<T>(value: T | T[], displayValue: (value: T) => string): SelectorItem<T> | SelectorItem<T>[] | PagedArray<SelectorItem<T>> {
		const transform = (value: T): SelectorItem<T> => this.with(value, displayValue(value));
		
		if (!Array.isArray(value)) {
			return transform(value);
		}
		
		let transformed = value.map(transform);
		
		return PagedArray.isPagedArray(value) ? PagedArray.from(transformed, value.page) : transformed;
	}
	
	private constructor() {}
}

export class SingleQuerySelectorItem<T> {
	private _value: [T] | T[] = [];
	private readonly onChangeSubject = new Subject<T | null>();
	readonly onChange$ = this.onChangeSubject.asObservable();
	
	constructor(startValue?: T) {
		if (startValue == null) return;
		this.value = startValue;
	}
	
	get value() {
		return this._value
	}
	
	set value(value: T | null | T[]) {
		if (Array.isArray(value)) {
			this._value = value.slice(0, 1);
		}
		else {
			this._value = value == null ? [] : [value];
		}
		
		this.onChangeSubject.next(this.getSingleValue());
	}
	
	getSingleValue() {
		return (this._value ?? [])[0] ?? null;
	}
}